export default __webpack_public_path__ + "static/media/pytorch.8653d1d6.svg";